import React, { Component } from "react";

import { getCookie, getUser, getAppEnv, getDoctorAccount } from "./Helpers";
import { getUserProfile } from "./Services";
// import { logoutAction, showLoader } from "./components/login/loginActions";
import UserContext from "./UserContext";
// import {
//   showLoader,
//   UpdateUserName
// } from "./components/profile/profileActions";

class SetCookiesToStorage extends Component {
  static contextType = UserContext;
  state = {
    appEnv: getAppEnv(),
    showLoader: true,
  };

  componentDidMount() {
    this.handleUserLogin();
  }

  /**
   * @function handleUserLogin
   * @desc this function handles setting cookies/logging put user
   * based upon the local storage user and cookie user
   */
  handleUserLogin = async () => {
    // fetch user cookie and user localstorage value
    // match the user id
    // if user id is same then do nothing
    // else clear the localstorage
    // so that noew cookie user can be set
    // const { UpdateUser } = this.props;

    const localUser = getUser();
    const { appEnv } = this.state;
    let cookieUser = getCookie(`${appEnv}_user`);
    cookieUser = cookieUser ? JSON.parse(cookieUser) : null;

    if (!localUser) {
      this.handleAuthCookies();
    } else if (localUser && cookieUser && localUser.id !== cookieUser.id) {
      // this is the case if some old user was present
      localStorage.clear();
      this.handleAuthCookies();
    } else if (localUser && cookieUser && localUser.id === cookieUser.id) {
      // set mixpanel properties
      //   history.push("/");
      this.context.setUserLoggedIn(true);
      this.context.setUserPhoto(getDoctorAccount()?.photo_url);
      this.context.setUserName(getDoctorAccount()?.doctor_name);
      this.setState({ showLoader: false });
    }
  };

  /**
   * @function handleAuthCookies
   * @desc this function handles setting cookies to local storage
   */
  handleAuthCookies = async () => {
    const { appEnv } = this.state;
    let userObj = getCookie(`${appEnv}_user`);
    const authToken = getCookie(`${appEnv}_authToken`);
    let userResponse = null;
    const refreshToken = getCookie(`${appEnv}_id_tkn`);

    if (userObj && authToken) {
      // get user data
      localStorage.setItem("authToken", authToken);
      if (refreshToken) localStorage.setItem("idt", refreshToken);
      // start loading

      this.setState({ showLoader: true });
      userResponse = await getUserProfile();
      // stop loading
      this.setState({ showLoader: false });
      if (userResponse?.data?.success) {
        // show loader at start, and hide it once localstorage is set, i.e. once setAuthDetails() method is done executing
        // userObj = userResponse.data.data;
        userObj = userResponse?.data?.data?.user;
        // setMixpanelProfileInfo(userObj);
        // if (userObj.signed_up_as === "patient") {
        localStorage.setItem("user", JSON.stringify(userObj));
        this.context.setUserLoggedIn(true);
        this.context.setUserPhoto(getDoctorAccount()?.photo_url);
        this.context.setUserName(getDoctorAccount()?.doctor_name);

        // history.push("/");
      } else {
        this.handleLoggedOutUsers();
      }
    } else {
      this.setState({ showLoader: false });
    }
  };

  /**
   * @function handleLoggedOutUsers
   * @desc this function handles logging out the user, if user is not authorized or if auth token is invalid
   */
  handleLoggedOutUsers = () => {
    // this.props.logout();
    this.context.setUserLoggedIn(false);
    this.context.setUserPhoto(null);
    this.context.setUserName("");
    this.setState({ showLoader: false });
  };

  render() {
    const { showLoader } = this.state;
    return (
      <div>
        {showLoader ? (
          <div className="page-loader">
            <div className="lds-roller">
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
              <div />
            </div>
          </div>
        ) : (
          this.props.children
        )}
      </div>
    );
  }
}

export default SetCookiesToStorage;
